export class ApiKeyGenerateRequestDto {
  name?: string;
  merchantGroupId?: number;
  merchantIds?: number[];
  isThirdParty?: boolean;
  thirdPartyType?: number;
  generatedPOSDeviceId?: number;
  isActive?: boolean;
}
